// extracted by mini-css-extract-plugin
module.exports = {"content":"styles__content___2GQdO","rightColumn":"styles__rightColumn___2IWPP","compressed":"styles__compressed___2tuZL"};